<script>
    import { slide } from 'svelte/transition';
    import { onMount } from 'svelte';

    let quiz;
    let submitted;
    let buttonColors = ["red", "beige", "blue", "lightbeige", "yellow"];
    let currentQuestion = 0;
    $: buttonColor = buttonColors[currentQuestion % buttonColors.length];
    $: cssVarStyles = `--progress:${updateProgress(currentQuestion)};`;
    onMount(async () => {
        const response = await fetch('api/questions');
        quiz = await response.json();
    })

    function scaleRange(number, [inMin, inMax], [outMin, outMax]) {
        return (number - inMin) / (inMax - inMin) * (outMax - outMin) + outMin;
    }
    function updateProgress(question) {
        if (!question || !quiz) {
            return "0%";
        }
        const progress = (question / quiz?.questions?.length) * 100;
        const scaledProgress = scaleRange(progress, [0, 100], [7, 93]);
        return `${scaledProgress}%`;
    }
    function clickAnswer(ev) {
        quiz.questions[currentQuestion].selected_answer = ev.target.value;
    }
    function previousQuestion() {
        if (currentQuestion > 0) {
            currentQuestion -= 1;
        }
        document.body.scrollIntoView(true);
    }
    function nextQuestion() {
        if (currentQuestion < quiz.questions.length) {
            currentQuestion += 1;
        }
        document.body.scrollIntoView(true);
    }
    async function submitQuestions() {
        const body = {
            quiz: quiz.id,
            responses: quiz.questions.map((question) => question.selected_answer)
        };
        const response = await fetch('api/response', {
            method: "POST",
            body: JSON.stringify(body)
        });
        if (response) {
            submitted = await response.json();
        }
    }
</script>

<main style="{cssVarStyles}" id="top">
{#if quiz === undefined}
    <center><p>Laddar...</p></center>
{:else}
  <div class="quiz">
    {#key currentQuestion}
    {#if currentQuestion < quiz.questions.length}
    <div class="question" transition:slide="{{ duration: 600 }}">
      <h1>{quiz.questions[currentQuestion].description}</h1>
      <div class="answers">
        {#each quiz.questions[currentQuestion].answers as answer}
        <button class="answer-button {buttonColor}" class:selected={quiz.questions[currentQuestion].selected_answer == answer.id} value="{answer.id}" on:click={clickAnswer}>
          {answer.description}
        </button>
        {/each}
      </div>

      <div class="actions">
        {#if currentQuestion > 0 && !submitted}
        <div class="action-button button-container left">
            <a href="#top" on:click={previousQuestion}><img src="/images/arrow-left.svg" class="arrow" alt="Förra"> </a>
        </div>
        {/if}
        {#if currentQuestion < quiz.questions.length && quiz.questions[currentQuestion].selected_answer && !submitted}
        <div class="action-button button-container right">
            <a href="#top" on:click={nextQuestion}><img src="/images/arrow-right.svg" class="arrow" alt="Nästa"></a>
        </div>
        {/if}
      </div>
    </div>
    {/if}
    {#if currentQuestion == quiz.questions.length && !submitted}
      <h1>Du har nu besvarat alla frågor</h1>
      <p>Klicka på "Skicka svar" för att få din svarskod.</p>

      <div class="actions">
        <div class="action-button button-container left">
            <a href="#top" on:click={previousQuestion}><img src="/images/arrow-left.svg" class="arrow" alt="Förra"> </a>
        </div>
        <div class="submit-button button-container right">
            <a href="#top" on:click={submitQuestions}><img src="/images/arrow-submit-answers.svg" class="arrow" alt="Skicka svar"></a>
        </div>
      </div>
    {/if}
    {#if submitted}
        <h1>Tack för dina svar!</h1>
        <p>Din svarskod är:</p>
        <h2 class="response-code">{submitted.code}</h2>
    {/if}
    {/key}

    <div class="progress-container">
      <img src="/images/progress-green.svg" alt="" class="progress progress-green">
      <img src="/images/progress-red.svg" alt="" class="progress progress-red">
    </div>
  </div>
{/if}
</main>

<style>
:root {
  --progress: 0%;
}

.answer-button {
  border: none;
  padding: 0.8em 2.5em;
  outline: none;
  color: #1d1d1b;
  z-index: 1;
  cursor: pointer;
  margin: 1rem 2rem;
}

.answer-button.selected {
  font-weight: 900;
  background: #1bc76a;
}

.red {
  background: #F55036;
 }
.beige {
  background: #FBBB93;
 }
.blue {
  background: #24B6E0;
 }
.lightbeige {
  background: #E6DCD7;
 }
.yellow {
  background: #FFE651;
 }

h1 {
  text-align: center;
  color: #1d1d1b;
  font-weight: 900;
  font-size: 2rem;
  max-width: 30rem;
  margin: 1rem;
}

h2.response-code {
  font-size: 4rem;
}

.quiz {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
}

.question {
  margin-bottom: 1rem;
  min-width: 20rem;
  max-width: 30rem;
}

@media screen and (min-width: 35.5em) {
  .question {
    width: 30rem;
  }
}

.answers {
  display: flex;
  flex-direction: column;
}

.actions {
  max-width: 30rem;
  width: 100%;
  min-height: 120px;
}

.action-button {
  width: 120px;
  height: 120px;
}

.submit-button {
  width: 245px;
  height: 120px;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.action-button a {
  color: #1d1d1b;
}

.action-button img {
  width: 80px;
  height: 80px;
  transition: all 0.1s ease-out;
}

.action-button img:hover {
  width: 90px;
  height: 90px;
}

.submit-button img {
  width: 215px;
  height: 80px;
  transition: all 0.1s ease-out;
}

.submit-button img:hover {
  width: 242px;
  height: 90px;
}

.left {
  float: left;
  margin-left: 1rem;
}

.right {
  float: right;
  margin-right: 1rem;
}

.progress-container {
  margin: 2rem;
  padding: 0;
  max-width: 30rem;
  width: 100%;
  margin-bottom: 2rem;
  position: relative;
}

.progress {
  width: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.progress-green {
  z-index: 1;
}

.progress-red {
  clip-path: inset(0 0 0 var(--progress, 0%));
  z-index: 2;
}

a {
  cursor: pointer;
}

a > img {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
